import { auth, onAuthStateChanged } from "../../../specific/services/Firebase/Firebase";
import User from "../../data/user/User";
import { dbListeners } from "./Database";

export const initAuth = () => {
    const userInstance: User = User.getInstance();
    const authSubscriber = onAuthStateChanged(auth, (user) => {
        userInstance.currentUser = user;
    });
    dbListeners.push(authSubscriber);
}